import * as React from 'react';

import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import { useState } from 'react';
import mediaQueries from 'src/constants/responsive';
import stylesheet from 'src/constants/stylesheet';

export type SplashProps = {};

const useStyles = makeStyles(() =>
  createStyles({

    splash: {
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100vh',
      width: '100vw',
      background: '#eee',
      zIndex: 99,
      transition: 'all 1s ease',

      '&$hide': {
        opacity: 0,
        pointerEvents: 'none'
      }
    },

    splashText: {
      position: 'absolute',
      top: '50%',
      right: 0,
      transform: 'translateY(-50%)',
      fontSize: '3.5vw',
      width: '100%',
      sansSeri: 'f',
      fontWeight: 700,
      fontStyle: 'normal',
      textAlign: 'center',
      ...stylesheet.BoldText
    },

    hideIntro: {
      opacity: 0,
      pointerEvents: 'none',
    },

    [mediaQueries.Mobile]: {
      splashText: {
        fontSize: '6vw',
      }
    },
    hide: {}

  }));

const Splash: React.FC<SplashProps> = () => {
  const cls = useStyles();
  const body = document.body;
  const [hideSplash, setHideSplash] = useState(false);

  React.useEffect(() => {
    if (!body || body.classList.contains('hide-intro')) { return };

    setTimeout(() => setHideSplash(true), 3000);
  }, []);

  return (
    <div className={classNames(cls.splash, hideSplash && cls.hide)} id='splash'>
      <h2 className={cls.splashText}>RABOUAN MOUSSION</h2>
    </div>
  );
}

export default Splash;



// WEBPACK FOOTER //
// ./src/Components/Splash.tsx